module.exports = __webpack_public_path__ + "static/PUCK_NEW_UJECIE_1v3v2-39b6ccff2216a2b474ac7ad8397338f8.jpg";